import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import dsBankApi from "service/TichHopBank/dsBankApi";
import userApi from "../../../service/userApi";
import { formatNumber } from "utils/currencyFormat";
import ReactToPrint from "react-to-print";
import { exportComponentAsPNG } from "react-component-export-image";
import { HopDongChoDuyet } from "components/BaoCao/HopDongChoDuyet";

export const ModelQRThanhToanHD = (props) => {
  const [dataBank, setDataBank] = useState({});
  const [bankId, setBankId] = useState("");
  const [user, setUser] = useState({});
  const [imgUrlQR, setImgUrlQR] = useState("");
  const [SoTienThanhToan, setSoTienThanhToan] = useState("");
  const updateSelect = () => (e) => {
    setBankId(e.target.value);
    const bank = dataBank.List.find((z) => z.Id == e.target.value);
    ShowQR(bank);
  };

  const ShowQR = (bank) => {
    var hopdong = props.hopdong;
    var noidung = user.IdCuaHang + " " + hopdong.ChoVayId + " TT ";
    if (typeof props.SoTien != "undefined") {
      noidung = " ThanhToan: " + hopdong.Code;
      var url =
        "https://img.vietqr.io/image/" +
        bank.MaBin +
        "-" +
        bank.SoTaiKhoan +
        "-qr_only.png?amount=" +
        props.SoTien +
        "&addInfo=" +
        noidung;
      setSoTienThanhToan(props.SoTien);
    } else if (typeof hopdong.TongTien != "undefined") {
      noidung = user.IdCuaHang + " " + hopdong.Id + " ChoTT ";
      var url =
        "https://img.vietqr.io/image/" +
        bank.MaBin +
        "-" +
        bank.SoTaiKhoan +
        "-qr_only.png?amount=" +
        hopdong.TongTien +
        "&addInfo=" +
        noidung;
      setSoTienThanhToan(hopdong.TongTien);
    } else if (typeof props.Value != "undefined") {
      var url =
        "https://img.vietqr.io/image/" +
        bank.MaBin +
        "-" +
        bank.SoTaiKhoan +
        "-qr_only.png?amount=" +
        props.Value +
        "&addInfo=" +
        noidung;
      setSoTienThanhToan(props.Value);
    } else {
      var url =
        "https://img.vietqr.io/image/" +
        bank.MaBin +
        "-" +
        bank.SoTaiKhoan +
        "-qr_only.png?amount=0&addInfo=" +
        noidung;
      setSoTienThanhToan(0);
    }
    setImgUrlQR(url);
  };

  const handleDownload = async () => {
    const response = await fetch(imgUrlQR);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = "QR" + props.hopdong.Code + ".png";
    link.click();

    URL.revokeObjectURL(blobUrl);
  };
  useEffect(() => {
    let callDanhSachBank = dsBankApi.list({
      sSearch: "",
      sMaNganHang: "",
      iPageSize: -1,
      iPageIndex: -1,
      isKhoa: 0,
      isDangKyNhanPushBDSD: null,
    });
    let config = userApi.getCurrentUser();

    Promise.all([callDanhSachBank, config]).then(([res1, res2]) => {
      setDataBank(res1.data);
      var obj = {
        IdCuaHang: res2.data.CompanyID,
      };
      setUser(obj);
    });
  }, []);
  useEffect(() => {
    if (typeof dataBank.List != "undefined") {
      ShowQR(dataBank.List[0]);
    }
  }, [user]);
  const componentRef = useRef();
  const renderQRThanhToan = () => {
    let { hopdong } = props;
    let { Code, CustomerName } = hopdong;
    return (
      <div class="col-sm-12" key={"QRCode"}>
        <div
          ref={componentRef}
          style={{
            display: "flex",
            position: "relative",
            width: 200,
            margin: "auto",
            justifyContent: "center",
          }}
        >
          <table class="table" style={{ border: "0px" }}>
            <tbody>
              <tr>
                <td style={{ border: "0px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 15,
                    }}
                  >
                    <p
                      style={{
                        display: "block",
                        whiteSpace: "nowrap",
                        fontSize: "14px",
                        mozTransform: "rotate(-90deg)",
                        mozTransformOrigin: "center center",
                        webkitTransform: "rotate(-90deg)",
                        webkitTransformOrigin: "center center",
                        msTransform: "rotate(-90deg)",
                        msTransformOrigin: "center center",
                        color: "#333333",
                        fontWeight: "900",
                        margin: "0px",
                        padding: "0px",
                      }}
                    >
                      {formatNumber(SoTienThanhToan)} VND
                    </p>
                  </div>
                </td>
                <td style={{ border: "0px" }}>
                  <div style={{ display: "block" }}>
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "0px 0 5px 0",
                        padding: "0px",
                        color: "#333333",
                        fontWeight: "900",
                      }}
                    >
                      {Code}
                    </p>
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "0px",
                        padding: "0px",
                      }}
                    >
                      <img src={imgUrlQR} style={{ width: "150px" }} />
                    </p>
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "0px 0 0px 0",
                        padding: "0px",
                        color: "#333333",
                        fontWeight: "900",
                      }}
                    >
                      {CustomerName}
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="footer-barcode text-center">
          {/* <ReactToPrint
            trigger={() => {
              // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
              // to the root node of the returned component as it will be overwritten.
              return (
                <button type="button" class="btn btn-new-main btn-checknew">
                  <span class="btn-icon-left">
                    <i class="mdi mdi-printer"></i>
                  </span>
                  In mã
                </button>
              );
            }}
            content={componentRef.current}
            copyStyles={false}
          /> */}
          <button
            className="btn btn-new-main btn-closenew ml-3"
            onClick={() => exportComponentAsPNG(componentRef)}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-cloud-download"></i>
            </span>
            Tải QR
          </button>
          <a
            className="btn btn-new-main btn-closenew ml-3"
            data-dismiss="modal"
            href={() => false}
            onClick={props.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>
            Đóng
          </a>
        </div>
      </div>
    );
  };

  return (
    <Modal
      {...props}
      size="modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="fade modal-new modal fade text-left modal show"
      backdrop="static"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-qrcode"></i>
          </span>
          Mã QR thanh toán hợp đồng {props.hopdong.Code}
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group row">
          <label className="col-md-4 label-control">
            Ngân hàng <span className="canh-bao-red">*</span>
          </label>
          <div className="col-md-8">
            <select
              class="form-control input-sm"
              value={bankId}
              onChange={updateSelect()}
            >
              {dataBank &&
                typeof dataBank.List !== "undefined" &&
                dataBank.List.map((item, idx) => (
                  <option key={"comboBank" + idx} value={item.Id}>
                    {item.MaNganHang + " - " + item.SoTaiKhoan}
                  </option>
                ))}
            </select>
          </div>
        </div>
        <div style={{ textAlign: "center" }}>{renderQRThanhToan()}</div>
        <div style={{ textAlign: "center" }}>
          <p></p>
        </div>
      </Modal.Body>
    </Modal>
  );
};
